import { render } from "./NewManage.vue?vue&type=template&id=5fed49b7&scoped=true"
import script from "./NewManage.vue?vue&type=script&lang=js"
export * from "./NewManage.vue?vue&type=script&lang=js"

import "./NewManage.vue?vue&type=style&index=0&id=5fed49b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fed49b7"]])

export default __exports__